import { ReportsModule } from "@/store/modules/report.module";
import { Machine, assign } from "xstate";
const entryReportMachine = Machine({
    id: "entryReportMachine",
    initial: "idle",
    context: {
        reportName: "",
    },
    states: {
        idle: {
            always: {
                target: "modalDormant",
            },
        },
        modalDormant: {
            on: {
                GETTING_HIGHLIGHT_AND_REPORT_TEMPLATE: { target: "modalActive" },
            },
        },
        modalActive: {
            initial: "gettingHighlightAndReportTemplate",
            on: {
                MAKE_MODAL_DORMANT: { target: "modalDormant" },
            },
            states: {
                gettingHighlightAndReportTemplate: {
                    tags: "gettingHighlightAndReportTemplate",
                    invoke: {
                        id: "gettingHighlightAndReportTemplate",
                        src: (context, event) => {
                            return ReportsModule.GetReportTemplateAndHighlightListForReports();
                        },
                        onDone: { target: "loadedHighlightAndReportTemplate" },
                        onError: { target: "#entryReportMachine.serviceUnavailable" },
                    },
                },
                loadedHighlightAndReportTemplate: {
                    on: {
                        EXPORTING_ENTRIES: { target: "exportingReport", actions: "assignReportName" },
                        MAKE_MODAL_DORMANT: { target: "#entryReportMachine.modalDormant" },
                    },
                },
                exportingReport: {
                    tags: "exportingReport",
                    invoke: {
                        id: "exportingReport",
                        src: (context, event) => {
                            return ReportsModule.ExportReport(event.entryReport);
                        },
                        onDone: { target: "#entryReportMachine.modalDormant", actions: "downloadReports" },
                        onError: { target: "#entryReportMachine.serviceUnavailable" },
                    },
                },
            },
        },
        serviceUnavailable: {
            tags: "serviceUnavailable",
        },
    },
}, {
    actions: {
        downloadReports: (context, event) => {
            const blob = new Blob([event.data], {
                type: "application/msword",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = `${context.reportName}.docx`;
            link.click();
            document.body.removeChild(link);
        },
        assignReportName: assign({
            reportName: (context, event) => event.reportName,
        }),
    },
    guards: {},
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
    },
});
export default entryReportMachine;
